import { Combobox } from '@eye-able/ui';
import type { ReactNode } from 'react';
import { useInlineTranslation } from '@/i18n/hooks/useInlineTranslation';

function FilterCombobox<Value>({
  label,
  items,
  value,
  onValueChange,
  itemToStringLabel,
  itemToStringValue,
  renderItemLabel,
  renderValue,
  clearable = true,
}: {
  label: string;
  items: Value[];
  value: Value | null;
  onValueChange: (value: Value | null) => void;
  itemToStringLabel?: (item: Value) => string;
  itemToStringValue?: (item: Value) => string;
  renderItemLabel?: (item: Value) => ReactNode;
  renderValue?: (item: Value) => ReactNode;
  clearable?: boolean;
}) {
  const { t } = useInlineTranslation();
  return (
    <div className='eye:w-[220px]'>
      <Combobox<Value>
        label={label}
        items={items}
        value={value}
        onValueChange={onValueChange}
        itemToStringLabel={itemToStringLabel}
        itemToStringValue={itemToStringValue}
        renderItemLabel={renderItemLabel}
        renderValue={renderValue}
        noItemsText={t('noMatches')}
        slotProps={{
          searchInput: {
            placeholder: t('searchFilter', {
              filter: label,
            }),
          },
          trigger: { showClear: clearable, className: 'eye:bg-white' },
          label: { className: 'eye:bg-label-gradient-grey' },
          value: { placeholder: t('all') },
        }}
      />
    </div>
  );
}

export default FilterCombobox;
